import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HourLinesSvg from './HourLinesSvg';
/**
 * This is to be used with InertiaSlider.
 *
 * Ratio for this scale is 96/60 (96 pixels is 60 minutes).
 */
export default function DurationScale({ minutes }) {
    const hours = Math.ceil((minutes + 1) / 60);
    return (_jsx("div", { className: "flex h-full items-center", children: Array.from({ length: hours }, (_, hourIndex) => {
            const scaleLeft = minutes - hourIndex * 60;
            const hLengthRel = scaleLeft > 0 ? 1 : Math.abs(scaleLeft) / 60;
            const hLength = hLengthRel * 96;
            return (_jsxs("div", { className: "mt-4 flex flex-col items-start", children: [_jsx("div", { className: "border-l-heading h-6 overflow-hidden border-l-2 pt-2 pl-1", style: { width: `${hLength}px` }, children: _jsx(HourLinesSvg, { color: "text-fg-disabled" }) }), _jsxs("div", { className: "text-body mt-1 -translate-x-1/2 text-xs", children: [hourIndex, "h"] })] }, hourIndex));
        }) }));
}
